import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <p className="text-sm font-medium text-primary-600">页面不存在</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold mt-4 text-foreground-950">哎呀，这片樱花瓣飘丢了</h2>
        <p className="mt-2 text-sm text-foreground-500">你访问的页面 {location.pathname} 不存在，或许被风吹走了。</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-primary-600"
        >
          <i className="ri-home-line"></i>
          回到首页
        </Link>
      </div>
    </div>
  );
}